import { render, staticRenderFns } from "./DialogVideoTeacher.vue?vue&type=template&id=7c8b9b5c&"
import script from "./DialogVideoTeacher.vue?vue&type=script&lang=js&"
export * from "./DialogVideoTeacher.vue?vue&type=script&lang=js&"
import style0 from "./DialogVideoTeacher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports